import { useMemo } from "react"
import { AchievementSalesByDate, calcSalesByDate } from "./calcSalesByDate"
import { useReportedApprovalRequestsByDays } from "@/hooks/useApprovalRequest"
import { DateString } from "@/utils/dateString"

export const useSalesByDate = ({
    dateStringInWeek
}: {
    dateStringInWeek: DateString[]
}): { salesByDate: AchievementSalesByDate } => {
    const { data: reportedApprovalRequestsByDays } =
        useReportedApprovalRequestsByDays({
            targetDates: dateStringInWeek
        })

    return useMemo(() => {
        const salesByDate = calcSalesByDate({
            dates: dateStringInWeek,
            reportedApprovalRequestsByDays
        })

        return { salesByDate }
    }, [dateStringInWeek, reportedApprovalRequestsByDays])
}
